export default "__VITE_ASSET__DRuVvasP__"